import { CIMSCollapseCountExtraProps } from './types'
import CIMSBadge from '../../../CIMSBadge'
import { Space } from 'antd'

const CIMSCollapseCountExtra: React.FC<CIMSCollapseCountExtraProps> = ({
  type: _type_ignored,
  children: _children_ignored,
  extra,
  extraPosition = 'left',
  ...rest
}) => {
  return (
    <Space size="small" align="center">
      {extraPosition === 'left' && extra}
      <CIMSBadge {...rest} />
      {extraPosition === 'right' && extra}
    </Space>
  )
}

export default CIMSCollapseCountExtra
